import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleMaster: IAbstractModule = {
  type: IModuleType.master,
  name: 'Master 3 (OLD)',
  hasScreen: true,
  columns: [
    [
      {
        name: "T15",
        connector: "15",
        cell_size_id: 4,
        accessible: false,
      },
      {
        name: "T16",
        connector: "16",
        cell_size_id: 4,
        accessible: true,
      },
      {
        name: "T18",
        connector: "18",
        cell_size_id: 4,
        accessible: false,
      },
    ],
  ]
};
